import { useEffect, useState } from "react";
import { Nav } from "@/components/portfolio/Nav";
import { Hero } from "@/components/portfolio/Hero";
import { ClientResults } from "@/components/portfolio/ClientResults";
import { TrustedBy, About, Services, WhyMe, Process, Testimonials, Pricing } from "@/components/portfolio/Sections";
import { VideoWall } from "@/components/portfolio/VideoWall";
import { Contact, Footer } from "@/components/portfolio/Contact";
import { api } from "@/lib/api";
import { WA_LINK } from "@/lib/site";

export default function PortfolioPage() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [portraitUrl, setPortraitUrl] = useState(null);
  const [contactVisible, setContactVisible] = useState(false);
  const [scrolledPast, setScrolledPast] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolledPast(window.scrollY > 550);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    api.get("/videos")
      .then(({ data }) => setVideos(data))
      .catch(() => setVideos([]))
      .finally(() => setLoading(false));
    api.get("/settings")
      .then(({ data }) => setPortraitUrl(data.portrait_url ? `${process.env.REACT_APP_BACKEND_URL}${data.portrait_url}` : null))
      .catch(() => {});
    // Hide the floating CTA while the contact section (or footer) is on screen
    const target = document.querySelector("#contact");
    if (target) {
      const obs = new IntersectionObserver(([e]) => setContactVisible(e.isIntersecting), { threshold: 0.05 });
      obs.observe(target);
      return () => obs.disconnect();
    }
  }, []);

  return (
    <div className="min-h-screen bg-cream text-ink font-sans" data-testid="portfolio-page">
      <Nav />
      <main>
        <Hero videos={videos} />
        <ClientResults />
        <TrustedBy />
        <VideoWall videos={videos} loading={loading} />
        <Services />
        <WhyMe />
        <Process />
        <About portraitUrl={portraitUrl} />
        <Testimonials />
        <Pricing />
        <Contact />
      </main>
      <Footer />
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-book-call"
        className={`md:hidden fixed bottom-4 right-4 z-40 bg-ink text-cream text-[11px] uppercase tracking-[0.14em] font-semibold px-5 py-3 rounded-full shadow-xl transition-all duration-300 ${
          contactVisible || !scrolledPast ? "opacity-0 translate-y-16 pointer-events-none" : "opacity-100 translate-y-0"
        }`}
      >
        Work With Me
      </a>
    </div>
  );
}
